import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import BulkDocumentUpload from '../components/BulkDocumentUpload';

const ImportCandidates: React.FC = () => {
  const navigate = useNavigate();
  const [success, setSuccess] = useState<string | null>(null);

  return (
    <Box>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate('/candidates')}
        sx={{ mb: 2 }}
      >
        Back to Candidates
      </Button>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>Upload Documents</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Upload resumes and cover letters for existing candidates. Supports PDF and DOCX files.
          Files are matched by filename patterns or by searching document content for candidate names and emails.
        </Typography>
        <Alert severity="info" sx={{ mb: 3 }}>
          <strong>Tip:</strong> Use "Import from PI" in the sidebar first to ensure all candidates have been added before uploading documents.
        </Alert>

        {success && (
          <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess(null)}>
            {success}
          </Alert>
        )}

        <BulkDocumentUpload onComplete={() => setSuccess('Documents uploaded successfully!')} />
      </Paper>
    </Box>
  );
};

export default ImportCandidates;